import { motion } from "framer-motion";
import bgPattern from "./assets/bg-patternT.svg";
import phonesGroup from "./assets/phonesGroup.jpg";

const fadeInLeft = {
  hidden: { opacity: 0, x: -50 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 1, ease: "easeOut" },
  },
};

const fadeInRight = {
  hidden: { opacity: 0, x: 60 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 1.2, ease: "easeOut" },
  },
};

const HomeAppPromo = () => {
  return (
    <section className="relative overflow-hidden bg-[#2563EB] text-white py-12 px-4 md:px-12 lg:px-16">
 
      <img
        src={bgPattern}
        alt="Background Pattern"
        className="absolute inset-0 w-full h-full object-cover opacity-100 pointer-events-none"
      />

      <div className="relative z-10 max-w-[1400px] mx-auto flex flex-col-reverse lg:flex-row items-center justify-between gap-10">

        <motion.div
          className="w-full max-w-xl text-center lg:text-left"
          variants={fadeInLeft}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          <motion.h2
            className="text-[26px] md:text-[34px] lg:text-[38px] font-semibold leading-snug mb-4"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
          >
            JIVIEWS aim is to help <br /> you to best
          </motion.h2>

          <motion.p
            className="text-sm md:text-base leading-relaxed text-white/90 max-w-md mx-auto lg:mx-0"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.1, delay: 0.2 }}
            viewport={{ once: true }}
          >
            utilize your workforce to improve operational efficiency of your
            organisation
          </motion.p>

          <a
            href="https://play.google.com/store/search?q=JIVIEWS&c=apps"
            target="_blank"
            rel="noopener noreferrer"
          >
            <motion.button
              className="mt-6 bg-white text-[#2563EB] font-semibold px-6 py-3 rounded-full shadow-lg hover:shadow-xl transition"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Get the App
            </motion.button>
          </a>
        </motion.div>

    
        <motion.div
          className="w-full flex justify-center lg:justify-end relative z-10"
          variants={fadeInRight}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          animate={{
            y: [0, -10, 0],
            transition: {
              duration: 2.5,
              repeat: Infinity,
              ease: "easeInOut",
            },
          }}
        >
          <motion.img
            src={phonesGroup}
            alt="JIVIEWS App Screens"
            className="w-[320px] sm:w-[420px] md:w-[500px] lg:w-[580px] xl:w-[620px] h-auto drop-shadow-2xl"
            whileHover={{ scale: 1.02 }}
            transition={{ type: "spring", stiffness: 100 }}
          />
        </motion.div>
      </div>
    </section>
  );
};

export default HomeAppPromo;
